<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.antecedents', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @reset="onReset" v-if="show">
                    <b-row>
                        <div class="form-group col-md-12">
                                <span class="obligatoire">*</span>
                                <label for="etablissement_id">{{ $t('message.nomEtablissement') }}</label>
                                <autocomplete
                                    :search="getEtablisssements"
                                    placeholder="Rechercher l'établissement"
                                    aria-label="Rechercher l'établissement"
                                    :get-result-value="getValueEtablissement"
                                    @submit="chooseEtablissement"
                                ></autocomplete>
                                <input type="hidden" name="etablissement_id" id="etablissement_id" v-model="$v.form.etablissement_id.$model" class="form-control" v-validate="'required'" :class="errors.has('etablissement_id') ? 'is-invalid' : ''"/>
                                <small id="emailHelp" class="form-text text-danger" v-if="$v.form.etablissement_id.$error">Rassurez-vous d'avoir sélectionné l'établissement</small> 
                            </div>
                    </b-row>
                    <b-row class="p-0">
                        <b-col sm="12">
                            <span class="obligatoire">*</span>
                            <b-form-group id="activity-group" :label="$t('message.activity')" label-for="activity">
                                <multiselect v-model="$v.form.activity_id.$model" :options="missions" :multiple="true" :close-on-select="true" :clear-on-select="false" :preserve-search="true" :placeholder="$t('message.activities')" label="description_fr" track-by="id"></multiselect>
                                <b-form-invalid-feedback v-if="$v.form.activity_id.$error">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>
                                <span v-if="errorshasField('activity_id')" style="color:red">
                                    {{getErrorsField('activity_id')}}
                                </span>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                    id="type-group"
                                    :label="$t('message.select')+' '+$tc('message.types',1)"
                                    label-for="type">
                                <!-- Options -->
                                <select id="type"
                                        v-model="$v.form.type.$model"
                                        required
                                        class="form-control is-invalid retirerBordure"
                                        :state="$v.form.type.$dirty ? !(errorshasField('type') || $v.form.type.$error) : null"
                                        @focus="clearErrorField('type')"
                                >
                                    <option v-for="item in types" :value="item.value" :key="item.value">
                                        {{ item.text }}
                                    </option>
                                </select>

                                <b-form-invalid-feedback v-if="$v.form.type.$error">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('type')">
                                    {{ getErrorsField('type') }}
                                </b-form-invalid-feedback>

                            </b-form-group>

                        </b-col>

                    </b-row>
                    <b-row>

                        <b-col sm="12">

                            <b-form-group
                                    id="date-group"
                                    :label="$t('message.startDate')"
                                    label-for="date"
                            >
                                <b-form-input
                                        id="date"
                                        v-model="$v.form.date.$model"
                                        :state="$v.form.date.$dirty ? !(errorshasField('date') || $v.form.date.$error) : null"
                                        type="date"
                                        required
                                        @click="clearErrorField('date')"
                                ></b-form-input>

                                <span v-if="errorshasField('date')" style="color:red">
                                    {{getErrorsField('date')}}
                                    </span>
                            </b-form-group>
                        </b-col>

                        <b-col sm="12">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                    id="description-group"
                                    :label="$t('message.description')"
                                    label-for="description"
                            >
                                <b-form-textarea
                                        id="description"
                                        v-model="$v.form.description.$model"
                                        :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                        required
                                        @focus="errorshasField('description')"
                                ></b-form-textarea>

                                <b-form-invalid-feedback v-if="!$v.form.description.required">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>
                                <b-form-invalid-feedback v-if="!$v.form.description.minLength">
                                    {{ $t('message.minCharacters', { n: 3 }) }}
                                </b-form-invalid-feedback>
                                <b-form-invalid-feedback v-else-if="errorshasField('description')">
                                    {{ getErrorsField('description') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="1">
                        </b-col>
                    </b-row>

                    <b-row class="justify-content-center" v-if="can">
                        <b-button @click="onSubmit" variant="primary">
                            {{ $t('message.save') }}
                        </b-button>

                        <!--                        <b-button type="reset" variant="danger">-->
                        <!--                            {{ $t('message.reset') }}-->
                        <!--                        </b-button>-->
                    </b-row>
                </b-form>

                <template v-if="rows">
                    <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            class="mb-3"
                            aria-controls="antecedents-table"
                    ></b-pagination>

                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col sm="12">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mAntecedents"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="antecedents-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mAntecedents"
                    >
                        <!-- A virtual compositeumn for actions -->
                        <template slot="action" slot-scope="data">
                            <div class="row" v-if="data.item.isAuthor || hasAdminRole">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-antecedent', params: { antecedent: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.antecedents', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.type }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteAntecedent(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="antecedents-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>

        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required,minLength } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import axios from "axios";
    import SlimSelect from 'slim-select';
    import moment from 'moment';
    import Multiselect from 'vue-multiselect';
    import AppConfig from "../../constants/AppConfig";
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'


    export default {
        name: "AddAntecedent",
        components: {
            Multiselect,
            Autocomplete,
        },
        computed: {
            ...mapGetters(["file", "errors", "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            info: function() {
                let file = this.file;
                if (typeof file.patient == 'object'){
                    if (!_.isUndefined(file.patient.user)){
                        let user = file.patient.user;
                        let prenom = (user.prenom != null ? user.prenom : '');
                        prenom =  prenom.toLowerCase();

                        let fullName = ( user.nom ).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);

                        return this.updateString(fullName) + ' (' + file.numero_dossier + ')';
                    }
                   return "";
                }
                return "";
            },

            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },

            mAntecedents: function() {
                let aArray = [];

                let self = this;

                if(typeof  this.file.antecedents == 'object'){
                    let antecedents = this.file.antecedents;
                    _.forEach(antecedents, function(antecedent) {
                        let a = {};
                        if (typeof antecedent.user == 'object'){
                            let user = antecedent.user;
                            let fullName =  user.prenom? user.prenom  : '' + (user.nom).toUpperCase();
                            a.patient = fullName+ " ( "+ antecedent.dossier.numero_dossier + " ) ";
                        }
                        a.type = antecedent.type;
                        a.description = self.updateString(antecedent.description);
                        a.date = moment(antecedent.date).isValid() ? moment(antecedent.date).format('DD-MM-YYYY') : "";
                        a.id = antecedent.id;
                        a.slug = antecedent.slug;
                        a.isAuthor = antecedent.isAuthor;

                        aArray.push(a);
                    });
                }
                return aArray;

            },

            rows: function() {
                return this.mAntecedents.length;
            }
        },

        data() {
            return {
                file_id: this.$route.params.file,
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                missions:[],
                sortDesc: true,
                fields: [
                    {
                        key: 'type',
                        label: this.$i18n.tc('message.types',1),
                    },
                    {
                        key: 'description',
                        label: this.$i18n.t('message.description'),
                    },
                    {
                        key: 'date',
                        label: this.$i18n.t('message.startDate'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],

                form: {
                    dossier_medical_id: null,
                    type: '',
                    description: '',
                    activity_id:'',
                    etablissement_id:null,
                    date: '',
                },
                show: true,
                types: [
                    { value: 'Médical', text: 'Médical' },
                    { value: 'Chirugical', text: 'Chirugical' },
                    { value: 'Gynéco-obstétrique', text: 'Gynéco-obstétrique' },
                    { value: 'Familial', text: 'Familial' }
                ],
            }
        },

        methods: {
            getGroupeActivites: function () {
                if(this.hasMedecinControleRole){
                    axios.get(AppConfig.apiUrl + "/referent-activites/list")
                    .then((res) => (this.missions = res.data.activites))
                    .catch((error) => {window.console.log(error)});
                }else{
                    axios.get(AppConfig.apiUrl + "/mission/list")
                    .then((res) => {this.missions = res.data.activites.map((x )=> ({
                        id: x.id,
                        description_fr: x.description_fr
                    }))})
                    .catch((error) => {window.console.log(error)});
                }
            },
            getFile() {
                let args = {
                    file: this.file_id
                };
                this.$store.dispatch("getMedicalFile", { args });
            },
            
            getEtablisssements(input){
                return new Promise(resolve => {
                    if (input.length < 2) {
                    return resolve([])
                    }
                    fetch(AppConfig.apiUrl+'/search/etablissements/'+input, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                    .then(res => {
                        resolve(res.etablissements)
                    }).catch(error => {
                        console.log('error ', error);
                    })
                })
            },
            getValueEtablissement(result) {
                return result.name
            },
            chooseEtablissement(result) {
                this.form.etablissement_id = result.id;
            },
            updateString(value){
                if (value.length>25){
                    return (value.substring(0,25))+"..."
                }
                return  value;
            },

            rowSelected(items) {
                this.$router.push({ name: 'antecedent', params: { antecedent: items[0].slug } });
            },

            formattedDisplay (result) {
                return result.type;
            },

            itemSelected(item) {
                this.$router.push({ name: 'antecedent', params: { antecedent: item.selectedObject.slug } });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        dossier_medical_id: this.file.id,
                        type: this.form.type,
                        description: this.form.description,
                        activity_id: this.form.activity_id,
                        etablissement_id: this.form.etablissement_id,
                        date: this.form.date
                    };

                    let successMessage = this.$i18n.t('message.antecedentCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createAntecedent', { args, errorMessages, successMessage })
                        .then(() => {
                            this.$v.$reset();
                            this.form.date = '';
                            this.form.description = '';
                            this.form.type = '';
                            this.form.etablissement_id = '';
                            this.clearErrorField('date');
                            this.$nextTick(() => { this.$v.$reset() })
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                //     evt.preventDefault();
                //
                //     // Reset our form values
                //     this.form.dossier_medical_id = '';
                //     this.form.type = '';
                //     this.form.description = '';
                //
                //     // Trick to reset/clear native browser form validation state
                //     this.show = false;
                //
                //     this.$nextTick(() => {
                //         this.show = true;
                //     });
            },

            deleteAntecedent(antecedent) {
                let self = this;

                let args = {
                    antecedent: antecedent
                };

                let successMessage = this.$i18n.t('message.antecedentDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteAntecedent', { args, index: antecedent, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + antecedent);
                    });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                // dossier_medical_id: {
                //     required
                // },
                activity_id: {
                    required
                },
                etablissement_id:{required},
                type: {
                    required
                },
                description: {
                    required,
                    minLength:minLength(3)
                },
                date: {

                }
            }
        },

        mounted() {
            // Retrieve medical file
            this.getFile();
            this.getGroupeActivites();
            new SlimSelect({
                select: '#type',
                placeholder: 'Select type'
            });
        }
    }
</script>

<style scoped src="vue-multiselect/dist/vue-multiselect.min.css">
    @import url('~slim-select/dist/slimselect.min.css');
</style>